import { writeStorage } from "@rehooks/local-storage";
import { useEffect, useState } from "react";

import useDarkMode from "../../hooks/useDarkMode.hook";
import SunIcon from "../../icons/sun.icon";
import MoonIcon from "../../icons/moon.icon";

export default function ApperanceToggleComp() {
  const [ready, setReady] = useState(false);
  const isDark = useDarkMode();

  // avoid the hydration mismatched
  useEffect(() => {
    setInterval(() => {
      setReady(true);
    }, 10);
  }, []);

  if (!ready) return <LightToggle />;

  return isDark ? <DarkToggle /> : <LightToggle />;
}

function DarkToggle() {
  return (
    <button
      className="flex gap-2 text-white"
      onClick={() => {
        writeStorage("theme", "light");
      }}
    >
      <SunIcon />
    </button>
  );
}

function LightToggle() {
  return (
    <button
      className="flex gap-2 text-gray-700"
      onClick={() => {
        writeStorage("theme", "dark");
      }}
    >
      <MoonIcon />
    </button>
  );
}
